import { DataType } from "ka-table";
import { TableColumn } from "../../../components/table/table";
import { ActionButton } from "../../../components/buttons/actionButtons";
import { DELETE, UPDATE } from "../../../constant/commonConst";
import { confirmBox } from "../../../components/toast";
import { ShowMoreCell } from "./showMore";

export const columns = (actions: any): TableColumn[] => {
  return [
    {
      key: "id",
      title: "id",
      dataType: DataType.Number,
      visible: false,
    },
    {
      key: "title",
      title: "Terms & Conditions",
      dataType: DataType.String,
      width: 250,
    },
    {
      key: "description",
      title: "Description",
      dataType: DataType.String,
      component: ShowMoreCell,
    },
    {
      key: "",
      title: "",
      component: ActionButton,
      callBack: async (row) => {
        if (row.status === UPDATE) {
          actions.openAddEditFrom({
            id: row.data.id,
            title: row.data.title,
            description: row.data.description
          });
        } else if (row.status === DELETE) {
          const response = await confirmBox("you want to delete this terms & conditions?");
          if (response) {
            actions.api.removeValue(row.data.id);
          }
        }
      },
      style: {
        textAlign: "center",
      },
    },
  ];
};
